export * from '@macs-frontend/features/ui-kit/base/ui-kit.base-component';
